module.exports = __webpack_public_path__ + "static/media/logo-round.8090d60a.png";